export default {
  methods: {
    /**
     * Get form rules from configuration of registration event.
     * form => rules => {}
     * "rules": {
     *     "math": ["(v) => { return this.membershipOption.includes('NCLD Math Collaborative $3000') ? !!v || 'Math Lead 1 is required' : true }"],
     *     "science": ["(v) => { return this.membershipOption.includes('NCLD Science Collaborative $3000') ? !!v || 'Science Lead 1 is required' : true }"]
     *  }
     */
    getRulesFromConfig: function(config) {
      return this.convertRulesToFunctions(this.extractByKeyString(config, 'content.form.rules', null));
    },
    /**
     * The rules are stored as JSON, JSON does not allow functions, so we store those as strings.
     * This will convert strings to functions we can use.
     */
    convertRulesToFunctions: function(rules) {
      var funcRules = {};

      if (rules) {
        for (var key in rules) {
          var rule = rules[key];

          var funcRule = [];
          for (var k in rule) {
            var r = rule[k];
            funcRule.push(eval(r));
          }
          funcRules[key] = funcRule;
        }
      }

      return funcRules;
    },
    /**
     * This will extract data from nested object/structure using dot notation
     * as a delimiter between keys (i.e. "key1.key2.key3").
     */
    extractByKeyString: function(data, valueString, defaultValue) {
      var keys =
        valueString && valueString.length ? valueString.split(".") : [];

      var numKeys = keys.length;

      var object = null;

      // Set null as default value if not defined.
      if (typeof defaultValue === "undefined") {
        defaultValue = null;
      }

      if (numKeys > 0 && keys[0] !== null && data.hasOwnProperty(keys[0])) {
        object = data[keys[0]];
      } else {
        return defaultValue;
      }

      for (var i = 1; i < numKeys; i++) {
        var key = keys[i];
        if (key !== null && object !== null && object.hasOwnProperty(key)) {
          object = object[key];
        } else {
          return defaultValue;
        }
      }

      return object;
    },
    /**
     * Use this to merge rules.
     */
    mergeRules: function(r1, r2) {
      var rules = Object.assign(r1);
      for (var key in r2) {
        var rule = r2[key];
        if (r1.hasOwnProperty(key)) {
          rules[key] = rule.concat(r1[key])
        } else {
          rules[key] = rule;
        }
      }
      return rules;
    },
    /**
     * Use this to replace rules.
     */
    replaceRules: function(r1, r2) {
      var rules = Object.assign(r1);
      for (var key in r2) {
        var rule = r2[key];
        if (r1.hasOwnProperty(key)) {
          rules[key] = r1[key];
        } else {
          rules[key] = rule;
        }
      }
      return rules;
    }
  }
}
